import { render } from "./reporting-details.vue?vue&type=template&id=cef1e366&lang=pug"
import script from "./reporting-details.vue?vue&type=script&lang=js"
export * from "./reporting-details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__